import "./BoilerRepair.module.css";
import Header from "@/reusable_sections/Header";
import EmergencyBoilerRepairs from "./sections/EmergencyBoilerRepairs";
import BoilerRepairDublin from "./sections/BoilerRepairDublin";
import RequestABoilerRepair from "./sections/RequestABoilerRepair";
import Footer from "@/reusable_sections/Footer";
export default function BoilerRepairPage() {
  return <div>
      <Header />
      <EmergencyBoilerRepairs />
      <BoilerRepairDublin />
      <RequestABoilerRepair />
      <Footer />
    </div>;
}